import { render, staticRenderFns } from "./EditarCertificadoModal.vue?vue&type=template&id=0a4ee1bc&"
import script from "./EditarCertificadoModal.vue?vue&type=script&lang=ts&"
export * from "./EditarCertificadoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports